import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import plTable from 'pl-table'
import 'pl-table/themes/index.css' // 引入样式（必须引入)，vuecli3.0不需要配置，cli2.0请查看webpack是否配置了url-loader对woff，ttf文件的引用,不配置会报错哦
import 'pl-table/themes/plTableStyle.css' // 默认表格样式很丑 引入这个样式就可以好看啦（如果你不喜欢这个样式，就不要引入，不引入就跟ele表格样式一样）
Vue.use(plTable);

import jquery from 'jquery'
Vue.prototype.$ = jquery

// import ECharts from 'vue-echarts' // 在 webpack 环境下指向 components/ECharts.vue

// // 手动引入 ECharts 各模块来减小打包体积
// import 'echarts/lib/chart/bar'
// import 'echarts/lib/component/tooltip'

// // 如果需要配合 ECharts 扩展使用，只需要直接引入扩展包即可
// // 以 ECharts-GL 为例：
// // 需要安装依赖：npm install --save echarts-gl，并添加如下引用
// import 'echarts-gl'
// // 注册组件后即可使用
// Vue.component('v-chart', ECharts)

import vueEsign from 'vue-esign'
Vue.use(vueEsign)

// import echarts from '@/lib/echarts.min.js';
// Vue.prototype.$echarts = echarts;

import tool from "@/lib/tool.js";
Vue.prototype.$tool = tool;
//公共方法
import pubjs from "@/lib/public.js";
Vue.prototype.$public = pubjs;

import Api from "@/lib/api.js";
Vue.prototype.$Api = Api.API;
Vue.prototype.$apiprototype=Api;
/**
 *请求
 **/
import apipost from '@/lib/apipost/apipost.js'
Vue.prototype.$apipost = apipost;

/**语言包**/
Vue.prototype.$lang={};
Vue.prototype.$langtype='cn';
// {label:{morefilter:{btnlabel:'更多筛选',starttime:'选择开始日期',endtime:'选择结束日期',commfilter:'常用筛选'}}}

Vue.config.productionTip = false;

Vue.prototype.$devicetype = '';

Vue.prototype.$theme='system_01';//系统样式主题
import('@/static/' + Vue.prototype.$theme + '/style/public.scss');

const VUE_APP_VERSION = require('../package.json').version
const vers = window.localStorage.getItem("appVersion");
if(VUE_APP_VERSION != vers){
  localStorage.clear()
  window.localStorage.setItem("appVersion", VUE_APP_VERSION);
  location.reload()
}
const start =async ()=>{ //异步初始化
	debugger
	var paraminfo={
		sys:'平台',
		mode:'public',
		lang:Vue.prototype.$langtype
	}
	Vue.prototype.$apipost.get.GetLanguageByMode({paraminfo:paraminfo}).then(res=>{
		if(res.label!=undefined){
			//debugger
			if(res.label.public!=undefined)
				Vue.prototype.$lang=res;
		}
	});
	//debugger
	Vue.prototype.$apipost.get.sysinfo().then(res => {
		if (res.info != '') {
			document.title = res.info.c_subwebtitle;
			localStorage.setItem('webtitle', res.info.c_webtitle);
			localStorage.setItem('c_folder', res.info.c_folder);
			if(res.info.theme!=undefined)
				Vue.prototype.$theme=res.info.theme;
			//localStorage.setItem('subwebtitle',res.info.c_subwebtitle);
			const app = new Vue({
				el: '#app',
				router,
				render: h => h(App)
			})
			app.$mount()
		}
	});
} 
start()

// new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app')
